import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import s from './ReviewAllList.module.scss';
import ReviewCard from '../../components/ReviewCard/ReviewCard';
import Pagination from '../../components/Pagination/Pagination';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Loading from '../../components/Loading/Loading';
import { Helmet } from 'react-helmet-async';
import titleImage from '../../assets/images/titleImage.png';

const PAGE_SEO_SLUG = 'reviews';
const DEFAULT_PAGE_TITLE = 'レビュー一覧';
const DEFAULT_SECONDARY_TITLE = 'Reviews';

const ReviewAllList = () => {
  const [reviews, setReviews] = useState([]);
  const [pageSeoTitles, setPageSeoTitles] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const reviewsPerPage = 10;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const breadcrumbItems = location.state?.breadcrumbItems || [
    { name: 'ホーム', link: '/' },
    { name: pageSeoTitles?.page_title || DEFAULT_PAGE_TITLE }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

  useEffect(() => {
    const fetchReviews = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/api/reviews`);
        if (!response.ok) {
          throw new Error('ネットワークエラー');
        }
        const data = await response.json();
        setReviews(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  // ページごとのレビューを計算
  useEffect(() => {
    const fetchPageSeoTitles = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/page-seo-titles/${PAGE_SEO_SLUG}`);
        if (!response.ok) return;

        const data = await response.json();
        setPageSeoTitles(data.data || null);
      } catch (err) {
        console.error(err);
        setPageSeoTitles(null);
      }
    };

    fetchPageSeoTitles();
  }, [apiUrl]);

  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = reviews.slice(indexOfFirstReview, indexOfLastReview);
  const totalPages = Math.ceil(reviews.length / reviewsPerPage);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  if (loading) {
    return (
      <div className={s.container}>
        <Loading loading={loading} />
      </div>
    );
  }

  if (error) return <div>Error: {error}</div>;

  return (
    <>
          <Helmet>
        <title>レビュー一覧 - ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】</title>
        <meta property="og:title" content="レビュー一覧 - ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】" />
        <meta property="og:image" content={`${process.env.REACT_APP_URL}/og-image.png`} />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/reviews`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />

      </Helmet>
    <div className={s.root}>
      <Breadcrumb items={breadcrumbItems} />
      <div className={s.titleWrrapper}>
        <img className={s.titleImage} src={titleImage} alt="" />
        <h2 className={s.primaryTitle}>{pageSeoTitles?.page_title || DEFAULT_PAGE_TITLE}</h2>
        <h3 className={s.secondaryTitle}>{pageSeoTitles?.secondary_title || DEFAULT_SECONDARY_TITLE}</h3>
      </div>
      <div className={s.cardContainer}>
        {currentReviews.map((review, index) => (
          <ReviewCard
            title={review?.tour?.title??""}
            rezdyId={review.rezdy_id}
            tourId={review.tour?.tour_id}
            stars={review.rating}
            date={review.participation_date}
            userType={review.attribute}
            userName={review.name}
            reviewTitle={review.title}
            review={review.body}
          />
        ))}
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
    </>
  );
};

export default ReviewAllList;
